import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtag from 'vue-gtag'
import App from './App.vue'
import router from './router'
import store from './store'
import './firebase/init'
import './firebase/authentication'
import vuetify from './plugins/vuetify'
import i18n from './i18n'

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: "UA-153146030-1" }
});
Vue.use(VueRouter)

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')
